module.exports = __webpack_public_path__ + "static/media/catalogue.a66d2b4d.pdf";